import './two-buttons.scss'
import type { GridElement } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import { CtaButton } from '@/common/components/ctaButton/CtaButton'
import type { TwoButtonsPropsApi } from './models'

export const TwoButtons: FC<GridElement<TwoButtonsPropsApi>> = ({ value }) => {
    const { leftButton, rightButton } = value

    return (
        <div className="two-buttons-wrapper">
            {leftButton && <CtaButton link={leftButton} buttonColor={{ label: 'black', color: 'black' }} />}
            {rightButton && <CtaButton link={rightButton} buttonColor={{ label: 'pink', color: 'pink' }} />}
        </div>
    )
}
